var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIOs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M20.874 14.345c-.034-3.419 2.788-5.059 2.914-5.14-1.586-2.32-4.058-2.64-4.938-2.675-2.103-.212-4.102 1.239-5.17 1.239-1.066 0-2.712-1.207-4.456-1.175-2.291.034-4.404 1.333-5.586 3.385-2.38 4.13-.609 10.253 1.712 13.603 1.134 1.64 2.485 3.483 4.26 3.417 1.71-.067 2.357-1.107 4.424-1.107s2.647 1.107 4.457 1.072c1.84-.034 3.005-1.673 4.131-3.318 1.303-1.904 1.837-3.745 1.87-3.84-.041-.018-3.588-1.376-3.623-5.46l.005-.001ZM17.475 4.31c.942-1.143 1.578-2.729 1.404-4.312-1.356.055-3.002.904-3.976 2.045-.874 1.013-1.638 2.628-1.434 4.179 1.515.118 3.063-.77 4.005-1.91l.001-.002Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h27v27H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIOs);
export default __webpack_public_path__ + "static/media/iOS.84594e4288bae6b2eaa223231fe47547.svg";
export { ForwardRef as ReactComponent };